<div class="dashboard-container">
    <app-build-widget></app-build-widget>
    <app-feature-flag-widget></app-feature-flag-widget>
</div>
